import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { saveAirway } from '../../procedures/airway/store/airway.actions'
import { QuickActionsConstants } from '../store/quickActions.constants'

export function* setAirwayQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addAirwayToTimeline } = quickActionsObject
  if (addAirwayToTimeline) {
    yield put(saveAirway())
  }
}

export function* setAirwayQuickActionTimeLineRowSaga() {
  yield takeLatest([QuickActionsConstants.SET_ADD_AIRWAY_TO_TIMELINE], setAirwayQuickActionTimeLineRow)
}
